module.exports = {"name":"xterm.attach","main":"attach.js","private":true}


//////////////////
// WEBPACK FOOTER
// ./~/xterm/lib/addons/attach/package.json
// module id = 9
// module chunks = 0